import {
  Flex,
  Text,
  HStack,
  Checkbox,
  IconButton,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
  useColorModeValue,
} from '@chakra-ui/react';
import { DeleteIcon } from '@chakra-ui/icons';

interface CollapsibleItemCardProps {
  title: string;
  subtitle?: string;
  isExcluded?: boolean;
  onExcludeChange?: (excluded: boolean) => void;
  onDelete: () => void;
  children: React.ReactNode;
}

const CollapsibleItemCard = ({
  title,
  subtitle,
  isExcluded,
  onExcludeChange,
  onDelete,
  children,
}: CollapsibleItemCardProps) => {
  const borderColor = useColorModeValue('gray.200', 'whiteAlpha.100');
  const showExcludeCheckbox = onExcludeChange !== undefined;

  return (
    <AccordionItem
      borderRadius="lg"
      mb={3}
      shadow="md"
      borderWidth="1px"
      borderColor={borderColor}
    >
      <AccordionButton
        _expanded={{ borderBottomRadius: 0 }}
        borderRadius="md"
        _hover={{ bg: 'gray.200' }}
        py={{ base: 3, md: 2 }}
      >
        <Flex
          flex="1"
          align={{ base: 'flex-start', sm: 'center' }}
          justify="space-between"
          pr={4}
          direction={{ base: 'column', sm: 'row' }}
          gap={{ base: 2, sm: 0 }}
        >
          {subtitle ? (
            <Flex direction="column" align="flex-start">
              <Text fontWeight="600" fontSize={{ base: 'sm', md: 'md' }}>
                {title}
              </Text>
              <Text fontSize="xs" color="gray.500">
                {subtitle}
              </Text>
            </Flex>
          ) : (
            <Text fontWeight="600" fontSize={{ base: 'sm', md: 'md' }}>
              {title}
            </Text>
          )}
          <HStack
            spacing={{ base: 2, md: 4 }}
            onClick={(e) => e.stopPropagation()}
          >
            {showExcludeCheckbox && (
              <Checkbox
                isChecked={isExcluded}
                onChange={(e) => onExcludeChange(e.target.checked)}
                borderColor="gray.400"
                colorScheme="gray"
                size="sm"
              >
                <Text fontSize="sm">Exclude</Text>
              </Checkbox>
            )}
            <IconButton
              aria-label="Delete"
              icon={<DeleteIcon />}
              size="sm"
              variant="ghost"
              colorScheme="red"
              onClick={onDelete}
            />
          </HStack>
        </Flex>
        <AccordionIcon />
      </AccordionButton>
      <AccordionPanel pb={4}>{children}</AccordionPanel>
    </AccordionItem>
  );
};

export default CollapsibleItemCard;
